var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            width: "25%",
            "class-name": "vertical-center-modal",
            "footer-hide": "",
            "mask-closable": false,
            closable: _vm.closable,
          },
          model: {
            value: _vm.dialogVisible,
            callback: function ($$v) {
              _vm.dialogVisible = $$v
            },
            expression: "dialogVisible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _vm.type
                ? _c("Icon", {
                    staticClass: "icon",
                    attrs: {
                      type: "ios-checkmark-circle",
                      size: "74",
                      color: "#0F75FF",
                    },
                  })
                : _c("Icon", {
                    staticClass: "icon",
                    attrs: {
                      type: "md-close-circle",
                      size: "74",
                      color: "#FF6639",
                    },
                  }),
              _vm.type
                ? _c(
                    "p",
                    { staticClass: "p-text" },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("check.submit")) + " "),
                      _vm._t("info"),
                    ],
                    2
                  )
                : _c(
                    "p",
                    { staticClass: "p-text" },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("check.noSubmit")) + " "),
                      _vm._t("error"),
                    ],
                    2
                  ),
              _c(
                "Button",
                {
                  staticClass: "modal-btn",
                  class: { "btn-success-color": _vm.type },
                  on: { click: _vm.ok },
                },
                [_vm._v(_vm._s(_vm.$t("common.ensure")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }